export const filterKeyPressNumber = (e: React.KeyboardEvent<HTMLInputElement>, regExp = /[0-9]/): void => {
  if (!regExp.test(e.key)) {
    e.preventDefault()
  }
}
